import { ScheduleDay } from 'types/schedules/default'

export const WEEK_DAYS: ScheduleDay[] = Object.values(ScheduleDay) // ['Su', 'M', 'T', 'W', 'Th', 'F', 'S']

/**
 * Returns the three letter representation of a day of the week
 * @param  {string} day Shortform of day ['M', 'T', 'W', 'Th', 'F', 'S', 'Su']
 *
 * @return {string}
 */
export function toThreeLetterWeekDay(day) {
  switch (day) {
    case ScheduleDay.Sunday:
      return 'Sun'
    case ScheduleDay.Monday:
      return 'Mon'
    case ScheduleDay.Tuesday:
      return 'Tue'
    case ScheduleDay.Wednesday:
      return 'Wed'
    case ScheduleDay.Thursday:
      return 'Thu'
    case ScheduleDay.Friday:
      return 'Fri'
    case ScheduleDay.Saturday:
      return 'Sat'
    default:
      return ''
  }
}

/**
 * Returns the full name of a day of the week
 * @param  {string} day Shortform of day ['M', 'T', 'W', 'Th', 'F', 'S', 'Su']
 *
 * @return {string}
 */
export function getWeekDay(day) {
  switch (day) {
    case ScheduleDay.Sunday:
      return 'Sunday'
    case ScheduleDay.Monday:
      return 'Monday'
    case ScheduleDay.Tuesday:
      return 'Tuesday'
    case ScheduleDay.Wednesday:
      return 'Wednesday'
    case ScheduleDay.Thursday:
      return 'Thursday'
    case ScheduleDay.Friday:
      return 'Friday'
    case ScheduleDay.Saturday:
      return 'Saturday'
    default:
      return ''
  }
}

/**
 * Returns the ISO numerical representation of a day of the week
 * @param  {string} day Shortform of day ['M', 'T', 'W', 'Th', 'F', 'S', 'Su']
 *
 * @return {number} ISO day of the week 1-7
 */
export function getIsoDayOfWeek(day) {
  return ['M', 'T', 'W', 'Th', 'F', 'S', 'Su'].indexOf(day) + 1
}
